import React from 'react';

export const newLiveRoute = [
  {
    path: '/newLive/home',
    component: React.lazy(() => import('@/views/NewLive/recommend')),
    meta: {
      title: '推荐'
    }
  },
  {
    path: '/newLive/allLive',
    component: React.lazy(() => import('@/views/NewLive/allLive')),
    meta: {
      title: '全部'
    }
  },
  {
    path: '/newLive/follow',
    component: React.lazy(() => import('@/views/NewLive/follow')),
    meta: {
      title: '关注'
    }
  },
  {
    path: '/newLive/studio',
    component: React.lazy(() => import('@/views/NewLive/studio')),
    meta: {
      title: '直播间'
    }
  },
  {
    path: '/newLive/search',
    component: React.lazy(() => import('@/views/NewLive/search')),
    meta: {
      title: '直播搜索'
    }
  }
];
